import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableLiveAppsConfigContent2 from './tableLiveAppsConfigContent2';

export default {
  title: 'App Config Contents',
  attributeName: 'appConfigContents',
  contentFormUrl:'liveAppContent',
  fields: [
    {
      attributeName: 'appConfigContentTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableLiveAppsConfigContent2,

    },
  ],
};
